// Stripe configuration helpers. Kept in a non-component file so the Fast Refresh
// "only-export-components" lint rule stays happy in StripeProvider.tsx.

export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY as string | undefined;

export const isStripeConfigured = (): boolean => Boolean(STRIPE_PUBLIC_KEY);
